import { render, staticRenderFns } from "./OzBadge.vue?vue&type=template&id=ae55d6c6&"
import script from "./OzBadge.vue?vue&type=script&lang=ts&"
export * from "./OzBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports